/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface PreviewImportTrackItMeasurementsForWorkItemDto
 */
export interface PreviewImportTrackItMeasurementsForWorkItemDto {
    /**
     * 
     * @type {string}
     * @memberof PreviewImportTrackItMeasurementsForWorkItemDto
     */
    jobOccurrenceId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewImportTrackItMeasurementsForWorkItemDto
     */
    workItemId: string;
    /**
     * 
     * @type {string}
     * @memberof PreviewImportTrackItMeasurementsForWorkItemDto
     */
    $type?: PreviewImportTrackItMeasurementsForWorkItemDtoTypeEnum;
}


/**
 * @export
 */
export const PreviewImportTrackItMeasurementsForWorkItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTrackItImportComponentDtoPreviewImportTrackItMeasurementsForWorkItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TrackItImportComponent.Dto.PreviewImportTrackItMeasurementsForWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PreviewImportTrackItMeasurementsForWorkItemDtoTypeEnum = typeof PreviewImportTrackItMeasurementsForWorkItemDtoTypeEnum[keyof typeof PreviewImportTrackItMeasurementsForWorkItemDtoTypeEnum];



/**
 * Check if a given object implements the PreviewImportTrackItMeasurementsForWorkItemDto interface.
 */
export function instanceOfPreviewImportTrackItMeasurementsForWorkItemDto(value?: unknown): value is PreviewImportTrackItMeasurementsForWorkItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PreviewImportTrackItMeasurementsForWorkItemDtoTypeEnum)[0];
}

export function PreviewImportTrackItMeasurementsForWorkItemDtoFromJSON(json: any): PreviewImportTrackItMeasurementsForWorkItemDto {
    return PreviewImportTrackItMeasurementsForWorkItemDtoFromJSONTyped(json, false);
}

export function PreviewImportTrackItMeasurementsForWorkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewImportTrackItMeasurementsForWorkItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'jobOccurrenceId': json['jobOccurrenceId'],
        'workItemId': json['workItemId'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PreviewImportTrackItMeasurementsForWorkItemDtoToJSON(value?: PreviewImportTrackItMeasurementsForWorkItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'jobOccurrenceId': value['jobOccurrenceId'],
        'workItemId': value['workItemId'],
        '$type': value['$type'],
    });
}

